import React from "react"

import Button from "@irati/ui/src/Button"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import Occasion from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {H5} from "@irati/ui/src/Typography"
import {ListItemWithActions} from "./styled"

interface Props extends InjectIntl {
  edit?: (occasion: Occasion) => void,
  item: Occasion,
  hide: (occasion: Occasion) => void,
  show: (occasion: Occasion) => void
}

const ListItem = ({item, hide, show, edit, formatMessage}: Props) => {
  const name = item.default ? formatMessage({id: item.name}) : item.name
  const iconHref = item.default ? formatMessage({id: item.icon.href}) : item.icon.href
  const iconAlt = item.default ? formatMessage({id: item.icon.alt}) : item.icon.alt
  return (
    <ListItemWithActions>
      <Flex alignItems="center">
        <img src={iconHref} alt={iconAlt} />
        <H5>{item.default ? <FormattedMessage id={name} /> : item.name}</H5>
      </Flex>
      <Flex>
        {!item.default && edit && (
          <Button marginLeft={2} small onClick={() => edit(item)}>
            <FormattedMessage id="admin.occasions.buttons.edit.label" />
          </Button>
        )}
        {item.archived ? (
          <Button id="settingsCompanyCelebrationShow_button" marginLeft={2} small onClick={() => show(item)}>
            <FormattedMessage id="admin.occasions.buttons.show.label" />
          </Button>
        ) : (
          <Button id="settingsCompanyCelebrationHide_button" marginLeft={2} small onClick={() => hide(item)}>
            <FormattedMessage id="admin.occasions.buttons.hide.label" />
          </Button>
        )}
      </Flex>
    </ListItemWithActions>
  )
}

export default injectIntl(ListItem)
